/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState, useCallback } from 'react'
import CardHeader from '../../../components/CardHeader';
// import Input from '../../../components/InputBox';
import Button from '../../../components/Button';
import { dataService } from '../../../services/data.services';
import { useNavigate, useParams } from 'react-router-dom';
import ErrorMessage from '../../../components/ErrorMessage';
import { validateEmail } from '../../../CommonMethods/EmailValidator';
import GlobalContext from "../../../components/Context/GlobalContext";
import LoadingOverlay from "react-loading-overlay-ts";
import FloatingInput from '../../../components/FloatinInput';
import { motion } from 'framer-motion'
import MerchantRoleSelection from '../../manageAdminUser/components/MerchantRoleSelection';
import { MerchantRoleList } from '../../../config/roles';
import InfiniteScroll from 'react-infinite-scroll-component'
import CardHeaders from '../../../components/CardHeaders';


export default function AddEmployee({ edit }) {

    const [submitSelected, setsubmitSelected] = useState(false)
    const { setToastmessage, setToastErrorMessage, setToastError } = useContext(GlobalContext)
    const [isOpen, setIsOpen] = useState(false)
    const [viewData, setviewData] = useState([]);
    const [loading, setloading] = useState(false)
    const [editData, seteditData] = useState({})
    const [error, setError] = useState("");
    const { email } = useParams();
    const { id } = useParams();
    const [errorState, seterrorState] = useState({});
    const navigate = useNavigate();
    const [invalidEmail, setinvalidEmail] = useState("")
    const [merchantRoles, setMerchantRoles] = useState({})
    const [page, setPage] = useState(1)
    const [totalCount, setTotalCount] = useState(1)
    const [tempData, setTempData] = useState(false)

    const handleDropdown = () => {
        setIsOpen(!isOpen);
    }
    function constructRoleObject(apiResponse) {
        const constructedObject = {};

        for (const [key, value] of Object.entries(MerchantRoleList)) {
            const subRoles = {};
            value.forEach(subRole => {
                // if (subRole === 'update_store_setting') {
                //     if (apiResponse.includes('update_store')) {
                //         subRoles[subRole] = true;
                //     }
                // }
                if (apiResponse.includes(subRole)) {
                    subRoles[subRole] = true;
                }
            });

            if (Object.keys(subRoles).length > 0) {
                constructedObject[key] = subRoles;
            }
        }

        return constructedObject;
    }
    const getData = useCallback(async () => {
        const res = await dataService.GetAPI(`stores/list?merchant=${encodeURIComponent(email)}&page_number=${page}`)
        setviewData(prevState => [...prevState, ...(res?.data?.data)]);
        setTotalCount(res?.data?.total_count)
    }, [page])
    const getEditData = async () => {
        try {
            let res = await dataService.GetAPI(`employees/${id}`);
            let tempobject = {
                name: res?.data?.name,
                phone_number: res?.data?.phone_number,
                merchant_privileges: res.data.merchant_privileges,
                store_name: res?.data?.store_name,
                email_address: res?.data?.email_address,
                store_email_address: res?.data?.store_email_address,
                merchant_email_address: res?.data?.merchant_email_address
            }
            const privileges = res?.data?.merchant_privileges;
            res.data.merchant_privileges = constructRoleObject(privileges);
            console.log(tempData, 'the api data for roles')
            setTempData(tempobject)
            setMerchantRoles(constructRoleObject(privileges))
            seteditData(tempobject);
            setState(tempobject);
        } catch (error) {
            setToastErrorMessage(error.message);
        }
    }

    useEffect(() => {
        if (edit) {
            getEditData();
        }
    }, []);
    useEffect(() => {
        getData();
    }, [getData]);

    const [state, setState] = useState({
        email_address: "",
        name: "",
        phone_number: "",
        store_name: "",
        store_email_address: "",
        merchant_email_address: email,
        merchant_privileges: ''
    });

    const handleValidation = (obj) => {
        const arr = [];
        const mykeys = {
            email_address: "",
            name: "",
            phone_number: "",
            store_name: "",
            store_email_address: "",
            merchant_email_address: email
        };
        Object.keys(mykeys).map((item) => {
            if (
                typeof obj[item] === "object"
                    ? obj[item].length === 0
                    : obj[item] === ""
            ) {
                arr.push(item);
            }
        });
        return arr.length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setsubmitSelected(true);
        setloading(true);
        setinvalidEmail("");
        seterrorState({});
        setError("")
        let body = state;

        body.name = body.name.trim();
        body.email_address = body.email_address.trim();
        body.phone_number = body.phone_number.trim();

        if (!handleValidation(body)) {
            setloading(false);
            window.scrollTo(0, 0);
            return;
        }

        if (validateEmail(state.email_address.trim())) {
            seterrorState({
                email_address: 'Invalid email address'
            })
            setloading(false);
            return;
        }
        if (state?.merchant_privileges?.length === 0) {
            setToastError('Choose at least one privilege')
            setloading(false);
            return;
        }
        if ((JSON.stringify(tempData) === JSON.stringify(merchantRoles))) {
            return;
        }
        try {
            
            let response;
            if (edit) {
                delete body._id
                delete body['status']
                delete body['user_type']
                delete body['is_deactivated']
                response = await dataService.PatchAPI(body, `employees/${id}`);
            }
            else {
                response = await dataService.PostAPI(body, `employees/onboard`);
            }
            setToastmessage(`Employee ${edit ? "details updated" : "added"} successfully`);
         
            navigate(-1);
        } catch (error) {
            setloading(false);
            window.scrollTo(0, 0);
            setToastError(error.response.data.message);
        }

    }


    const handleInput = (key, value, drop) => {
        // setToastErrorMessage("");
        const phoneNumberRegex = /^\+?\d{0,15}$/;
        // const { id, value } = e.target
        if (key === 'phone_number' && value !== '') {
            if (!phoneNumberRegex.test(value)) {
                return;
            }
        }
        if (drop) {
            setState((prv) => ({
                ...prv,
                "store_name": drop.name,
                "store_email_address": drop.email_address
            }));
        } else {
            // const { id, value } = e.target;
            setState((prv) => ({
                ...prv,
                [key]: value,
            }));
        }

    };

    return (

        <CardHeaders
            header={edit ? "Edit Employee" : "Add Employee"}
            paths={["Merchants", "Merchant Details"]}
            pathurls={['/manage-merchants',`/${email}/view`]}
            // back={`/manage-merchants/${id}/view`}
            activePath={edit ? 'Edit Employee' : "Add Employee"}
            back={-1}
        >
            <LoadingOverlay active={edit ? Object?.keys(editData)?.length === 0 : false} spinner text="Fetching Employee details...">


                <div className='bg-[#f5f5f5] px-[13px] py-[14px] overflow-y-hidden'>
                    <div className="bg-white h-customh10 overflow-y-auto scrollHide">
                        <div className=" pt-8 px-6 pb-6">
                            <p className=" text-xl font-playfair font-medium text-[#4B4B4B]">
                                Employee Details
                            </p>
                        </div>
                        <div className='flex -mx-2.5 px-6'>
                            <div className='w-1/4 px-2.5 '>
                                <div className="relative">
                                    <FloatingInput
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        value={state?.name}
                                        id="name"
                                        handleInput={handleInput}
                                        state={state.name}
                                        classKey={`${submitSelected && !loading && (state.name.trim() === '' || (errorState['name'] && errorState['name'] !== ''))
                                            ? "input-error"
                                            : "input-border"
                                        } w-full font-semibold pl-3 pr-3  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                        labelCalss={`${submitSelected && !loading && (state.name.trim() === '' || (errorState['name'] && errorState['name'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute text-[#1F1F1F] block ${state?.name?.length > 0 ? 'font-normal' : 'font-semibold'} leading-tigh text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F] peer-focus:font-normal peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}
                                        // errorImage="email-error.svg"
                                        // normalImage="email.svg"
                                        text="Employee name"
                                        errorState={errorState}
                                        placeholder={edit ? ' ' : ''}
                                        maxLength="64"
                                    />
                                </div>
                            </div>
                            <div className='w-1/4  px-2.5 '>
                                <div className={` relative ${edit ? 'pointer-events-none' : ''}`}>
                                    <FloatingInput
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        value={state.email_address}
                                        id="email_address"
                                        handleInput={handleInput}
                                        state={state.email_address}
                                        classKey={`${submitSelected && !loading && (state.email_address.trim() === '' || (errorState['email_address'] && errorState['email_address'] !== ''))
                                            ? "input-error"
                                            : "input-border"
                                        } w-full font-semibold pl-3 pr-3  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer ${edit ? 'text-[#1F1F1F]' : 'text-[#1F1F1F]'}`}
                                        labelCalss={`${submitSelected && !loading && (state.email_address.trim() === '' || (errorState['email_address'] && errorState['email_address'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1 ${state?.email_address?.length > 0 ? 'font-normal' : 'font-semibold'} absolute text-[#1F1F1F] block  leading-tigh text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F] peer-focus:font-normal  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}
                                        // errorImage="email-error.svg"
                                        // normalImage="email.svg"
                                        text="Email address"
                                        errorState={errorState}
                                        placeholder={edit ? ' ' : ''}
                                        disabled={edit}
                                        maxLength="100"
                                    />
                                    {/* {submitSelected &&
                                    state.email_address !== "" &&
                                    validateEmail(
                                        state.email_address || invalidEmail !== ""
                                    ) && (
                                        // eslint-disable-next-line react/jsx-indent
                                        <ErrorMessage message="Invalid email address" error />
                                    )}
                                {submitSelected && error !== "" && (
                                    <ErrorMessage message={error} error />
                                )} */}
                                </div>
                            </div>
                            <div className='w-1/4 px-2.5 '>
                                <div className=" relative">
                                    <FloatingInput
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        value={state?.phone_number}
                                        id="phone_number"
                                        handleInput={handleInput}
                                        state={state.phone_number}
                                        classKey={`${submitSelected && !loading && (state.phone_number.trim() === '' || (errorState['phone_number'] && errorState['phone_number'] !== ''))
                                            ? "input-error"
                                            : "input-border"
                                        } w-full font-semibold pl-3 pr-3  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                        labelCalss={`${submitSelected && !loading && (state.phone_number.trim() === '' || (errorState['phone_number'] && errorState['phone_number'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute text-[#1F1F1F] block ${state?.phone_number?.length > 0 ? 'font-normal' : 'font-semibold'} leading-tigh text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F] peer-focus:font-normal peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}
                                        // errorImage="email-error.svg"
                                        // normalImage="email.svg"
                                        text="Phone number"
                                        errorState={errorState}
                                        placeholder={edit ? ' ' : ''}
                                        maxLength={15}

                                    />
                                </div>
                            </div>
                            <div className='w-1/4 px-2.5 '>
                                <div className="dropdown"  >
                                    <div className={`w-full relative`}>
                                        <div className='relative w-full'>
                                            <input
                                                type="text"
                                                className={`${submitSelected && (state.store_name === "" || !state.store_name) ? "input-error" : "input-border"} peer m-0 block pt-4 h-[58px] w-full cursor-pointer rounded border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 text-base font-semibold leading-tight text-black transition duration-200 ease-linear placeholder:text-transparent focus:border-black focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-black focus:outline-none peer-focus:text-black dark:border-neutral-600 dark:text-black  dark:focus:border-primary dark:peer-focus:text-primary`}
                                                id="currency"
                                                data-testid="store_dropdown"
                                                placeholder=" "
                                                onClick={() => {
                                                    setsubmitSelected(false);
                                                    handleDropdown();
                                                }
                                                }
                                                value={state?.store_name}
                                                readOnly
                                            />
                                            <label htmlFor='currency' className={`${submitSelected && (state.store_name === '' || !state.store_name || (errorState['store_name'] && errorState['store_name'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 absolute text-[#1F1F1F] block duration-300 transform -translate-y-4 scale-75 top-[18px] z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 ${state?.store_name === '' || !state?.store_name ? 'text-base font-semibold' : 'text-lg font-normal peer-focus:-translate-y-4 peer-focus:scale-75'} `}>Store name</label>

                                            <motion.img
                                                animate={{ rotate: isOpen === true ? 180 : 0 }}
                                                src={`${submitSelected && (state?.store_name === '' || !state?.store_name || (errorState['store_name'] && errorState['store_name'] !== '')) ? '/assets/images/error-chevron-down.svg' : '/assets/images/chevron-down.svg'}`}
                                                alt=""
                                                className="absolute top-4 right-5 cursor-pointer"
                                                onClick={() => handleDropdown()}
                                            />
                                            {isOpen && <ul className="dropdown-menu absolute scrollBar w-full z-[100] max-h-[162px]  overflow-y-auto bg-white">
                                                {/* {currencies?.length > 0 && currencies?.map((item, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => {
                                                        setDropdown(false);
                                                        handleInput("currency", item?.code, "dropdown");
                                                    }}
                                                    data-testid={`currency-${index}`}
                                                    className="dropdown-item cursor-pointer w-full px-4 py-4 border border-[#DDDDDD] hover:bg-[#EB9DC7] rounded-[2px] text-sm font-semibold text-[#1F1F1F]"
                                                >
                                                    {item.code} - {item.name}
                                                </li>
                                            ))
                                            } */}
                                                <InfiniteScroll
                                                    dataLength={viewData?.length}
                                                    pageStart={1}
                                                    // height={162}
                                                    className='scrollBar'
                                                    next={() => { setPage(prevPage => prevPage + 1) }}
                                                    hasMore={Math.ceil(totalCount / 10) === page ? false : true}
                                                    useWindow={false}>
                                                    {viewData.length > 0 ? viewData.map((item, index) => (

                                                        <li
                                                            key={index}
                                                            onClick={() => {
                                                                setIsOpen(false);
                                                                handleInput("store_name", item, item)
                                                            }}
                                                            data-testid={`store_dropdown_item_${index}`}
                                                            // eslint-disable-next-line max-len
                                                            className="dropdown-item cursor-pointer w-full px-4 py-4 border border-[#DDDDDD] hover:bg-[#EB9DC7] rounded-[2px] text-sm font-semibold text-[#1F1F1F] overflow-hidden text-ellipsis whitespace-nowrap"
                                                        >
                                                            {item.name}
                                                        </li>

                                                    )

                                                    ) :
                                                        (<div className='border border-[#DDDDDD] h-[100px] flex justify-center items-center'>
                                                            No stores available yet
                                                        </div>)

                                                    }
                                                </InfiniteScroll>

                                            </ul>}
                                            {submitSelected && (state?.store_name === '' || !state?.store_name) &&
                                                <ErrorMessage error message={'This field is mandatory'}
                                                    classKey={'text-f1 font-normal text-[#F04438] add-error2 pt-1.5'} />}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" mt-6 mb-6 px-6">
                            <p className=" text-xl font-playfair font-medium text-[#4B4B4B]">
                                Employee Privileges
                            </p>
                        </div>
                        <div className='px-6'>
                            <MerchantRoleSelection
                                error={submitSelected}
                                handleValidation={handleValidation}
                                state={state}
                                setstate={setState}
                                checkedRoles={merchantRoles}
                                setCheckedRoles={setMerchantRoles}
                                employee
                            />
                        </div>

                        <div className='px-6 mt-6'>
                            <div className="-mx-2.5 w-1/3">


                                <div class=" px-2.5  w-full">
                                    <Button
                                        handleClick={handleSubmit}
                                        loading={loading}
                                        disabled={loading || (JSON.stringify(tempData) === JSON.stringify(state))}
                                        text={edit ? "Update" : "Add"}
                                        classKey={`w-full px-4 py-[10px] ${(JSON.stringify(tempData) === JSON.stringify(state)) ? 'opacity-[0.3]' : ''} bg-primary rounded-[12px] text-white text-lg font-bold mb-8`}
                                        type="submit"
                                        testId="addstore"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </LoadingOverlay>
        </CardHeaders >

    )
}
